// NewsletterEdit.jsx
import React from "react";
const emptyNewsletter = {
  id: "",
  subject1: "",
  name: "Dear Friend",
  section1: "",
  section2: "",
  blessings: "",
  regions: "",

  events: [
    { name: "", dates: "", image: "", url: "" },
    { name: "", dates: "", image: "", url: "" },
    { name: "", dates: "", image: "", url: "" }
  ],

  videos: [
    { title: "", subtitle: "", image: "", url: "" },
    { title: "", image: "", url: "" },
    { title: "", image: "", url: "" }
  ],

  unsubscribe_url: "https://graceanointing.org/unsubscribe"
};


export default function NewsletterEdit({ value, onSave, onBack }) {
  const update = (k, v) => onSave({ ...value, [k]: v });

  const updateEvent = (i, k, v) => {
    const events = [...value.events];
    events[i][k] = v;
    onSave({ ...value, events });
  };

  const updateVideo = (i, k, v) => {
    const videos = [...value.videos];
    videos[i][k] = v;
    onSave({ ...value, videos });
  };

  return (
    <div style={{ padding: 24, maxWidth: 900 }}>
      <button onClick={onBack} style={{ marginBottom: 16 }}>
        ← Back
      </button>

      <h2>Edit Newsletter</h2>

      <Input label="Subject" value={value.subject1} onChange={v => update("subject1", v)} />
      <Input label="Recipient Name" value={value.name} onChange={v => update("name", v)} />
      <TextArea label="Section 1" value={value.section1} onChange={v => update("section1", v)} />
      <TextArea label="Section 2" value={value.section2} onChange={v => update("section2", v)} />
      <Input label="Blessing" value={value.blessings} onChange={v => update("blessings", v)} />
      <Input label="Region" value={value.regions} onChange={v => update("regions", v)} />

      <h3>Events</h3>
      {value.events.map((e, i) => (
        <Card key={i} title={`Event ${i + 1}`}>
          <Input label="Title" value={e.name} onChange={v => updateEvent(i, "name", v)} />
          <Input label="Dates" value={e.dates} onChange={v => updateEvent(i, "dates", v)} />
          <Input label="Image URL" value={e.image} onChange={v => updateEvent(i, "image", v)} />
          <Input label="Link URL" value={e.url} onChange={v => updateEvent(i, "url", v)} />
        </Card>
      ))}

      <h3>Videos</h3>
      {value.videos.map((v, i) => (
        <Card key={i} title={i === 0 ? "Featured Video" : `Video ${i + 1}`}>
          <Input label="Title" value={v.title} onChange={val => updateVideo(i, "title", val)} />
          {i === 0 && (
            <Input label="Subtitle" value={v.subtitle} onChange={val => updateVideo(i, "subtitle", val)} />
          )}
          <Input label="Image URL" value={v.image} onChange={val => updateVideo(i, "image", val)} />
          <Input label="Video URL" value={v.url} onChange={val => updateVideo(i, "url", val)} />
        </Card>
      ))}

      <button style={btnPrimary} onClick={onBack}>
        Save
      </button>
    </div>
  );
}

const Input = ({ label, value, onChange }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontSize: 12 }}>{label}</label>
    <input value={value} onChange={e => onChange(e.target.value)}
           style={{ width: "100%", padding: 8 }} />
  </div>
);

const TextArea = ({ label, value, onChange }) => (
  <div style={{ marginBottom: 12 }}>
    <label style={{ fontSize: 12 }}>{label}</label>
    <textarea rows="3" value={value} onChange={e => onChange(e.target.value)}
              style={{ width: "100%", padding: 8 }} />
  </div>
);

const Card = ({ title, children }) => (
  <div style={{ border: "1px solid #ddd", padding: 16, marginBottom: 16 }}>
    <strong>{title}</strong>
    <div style={{ marginTop: 12 }}>{children}</div>
  </div>
);

const btnPrimary = {
  padding: "10px 18px",
  background: "#ca2d0d",
  color: "#fff",
  border: "none",
  borderRadius: 6
};
